export const receiveAccounts = accounts => {
  return {
    type: 'RECEIVE_ACCOUNTS',
    accounts
  }
}
